<template>
    <div>
        <div v-if="loading" class="text-center py-4">
            <b-spinner label="Chargement..."></b-spinner>
        </div>
        <div v-else-if="error" class="alert alert-danger">
            {{ error }}
        </div>
        <div v-else-if="tableData.rows && tableData.rows.length === 0" class="alert alert-info">
            Aucune donnée pour cette année.
        </div>
        <b-table
            v-else
            responsive
            small
            :items="tableData.rows"
            :fields="fields"
            class="number-font"
        >
            <template #cell(label)="data">
                <span>{{ data.value }}</span>
            </template>
            <template #cell(nb_clients)="data">
                <span class="text-right d-block">{{ data.value }}</span>
            </template>
            <template #cell(total)="data">
                <span class="text-right d-block number-font">{{ data.value }}</span>
            </template>
            <template #custom-foot>
                <b-tr class="bg-light font-weight-bold">
                    <b-th>TOTAL</b-th>
                    <b-th class="text-right">{{ tableData.totalRow ? tableData.totalRow.nb_clients : '' }}</b-th>
                    <b-th v-for="(val, idx) in (tableData.totalRow && tableData.totalRow.cells ? tableData.totalRow.cells : [])" :key="'foot-' + idx" class="text-right number-font">{{ formatNumber(val) }}</b-th>
                    <b-th class="text-right number-font">{{ tableData.totalRow ? formatNumber(tableData.totalRow.total) : '' }}</b-th>
                </b-tr>
            </template>
        </b-table>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DashboardFeesSynthesisTable',

    data() {
        return {
            loading: false,
            error: null,
            tableData: {
                companies: [],
                headers: [],
                rows: [],
                totalRow: null,
            },
        }
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),

        fields() {
            if (!this.tableData.headers || this.tableData.headers.length === 0) {
                return []
            }
            const h = this.tableData.headers
            const f = [
                { key: 'label', label: h[0] || '', thClass: 'text-left' },
                { key: 'nb_clients', label: h[1] || 'Nb clients', thClass: 'text-right' },
            ]
            const numCols = this.tableData.headers.length >= 3 ? this.tableData.headers.length - 3 : (this.tableData.totalRow && this.tableData.totalRow.cells ? this.tableData.totalRow.cells.length : 0)
            for (let i = 0; i < numCols; i++) {
                f.push({ key: `cell_${i}`, label: h[2 + i] || '', thClass: 'text-right', tdClass: 'text-right number-font' })
            }
            f.push({ key: 'total', label: h[h.length - 1] || 'TOTAL', thClass: 'text-right', tdClass: 'text-right number-font' })
            return f
        },
    },

    watch: {
        year() {
            this.getData()
        },
    },

    mounted() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'fees-synthesis')
        this.getData()
    },

    methods: {
        async getData() {
            this.loading = true
            this.error = null
            try {
                const response = await axios.get(`dashboard/fees/by-cabinet-matrix/${this.year}`)
                const data = response.data.data
                const rows = (data.rows || []).map((row) => {
                    const item = {
                        label: row.label,
                        nb_clients: row.nb_clients,
                        total: this.formatNumber(row.total),
                    }
                    if (row.cells && Array.isArray(row.cells)) {
                        row.cells.forEach((val, idx) => {
                            item[`cell_${idx}`] = this.formatNumber(val)
                        })
                    }
                    return item
                })
                this.tableData = {
                    companies: data.companies || [],
                    headers: data.headers || [],
                    rows,
                    totalRow: data.totalRow || null,
                }
            } catch (e) {
                this.error = e.response && e.response.data && e.response.data.message ? e.response.data.message : 'Erreur lors du chargement.'
                this.tableData.rows = []
                this.tableData.totalRow = null
            } finally {
                this.loading = false
            }
        },

        formatNumber(value) {
            const n = Number(value)
            if (n === 0 || Number.isNaN(n)) return '-'
            return n.toLocaleString('fr-FR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })
        },
    },
}
</script>
